<template>
     <dialog-layout ref="businessesDialog" id="businessesDialog" @click="dialogActions">
        <h3 slot="headercontent">Businesses</h3>
         <businesses-layout :businesses="businesses">
          <template slot="buttons" slot-scope="{business}">                
              <p>                 
                <large-button @click="$emit('link',business);cancelDialog()">Link</large-button>                                     
              </p>
          </template>
         </businesses-layout>
   
    </dialog-layout>  

</template>

<script>
import {mapActions} from "vuex";
export default {      
  data: function() {
    return {
        businesses:null,
        meta:null
    };
  },
  props:["selectedBusinesses"],
  methods: {        
    ...mapActions(['fullbusiness']),
    show(args){   
      //let clients know about      
      this.fullbusiness().then((fs)=>{
          let test = this.selectedBusinesses || {}
          let unselectedbusiness = Object.keys(fs).reduce((accum,key)=>{
                if(!test[key])
                  accum[key] = fs[key]
                return accum
          },{})

          this.businesses = unselectedbusiness // || business  
          this.meta = args?meta||null:null
          this.$refs.businessesDialog.show()      
      })        
    },
    cancelDialog(){      
        this.$refs.businessesDialog.cancelDialog(this)                   
    },
    dialogActions(e) {         
      if(e.action==='canceldialog')
      {
        this.business = null
        this.meta = null       
      }        
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/shared/BusinessesLinksDialog.vue